import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'
import { CheckCircleOutlineUnchecked } from '@carvana/icons';
import { CheckCircle } from '@carvana/purchase-styles';

const iconSize = '21px';

const CheckCircleEmpty = styled(CheckCircleOutlineUnchecked)`
  color: ${props => props.theme.carvana.gray.light};

  & > svg {
    height: ${iconSize};
    width: ${iconSize};
  }
`;

const DocumentStatusIcon = ({ status }) => {
  switch (status?.toLowerCase()) {
    case 'complete':
      return <CheckCircle $green $size={iconSize} />;

    case 'incomplete':
      return <CheckCircle $size={iconSize} />;

    default:
      return <CheckCircleEmpty />;
  }
};

DocumentStatusIcon.propTypes = {
  status: PropTypes.string.isRequired,
};

export default DocumentStatusIcon;
